import { useSelfServiceAccount } from '@eneco/auth-be-self-service';
import logger from '@eneco/common/log';
import RichText from '@eneco/components/RichText/RichText';
import {
  PushDirectDebitCardResponse,
  deleteEnecoBeXapiSiteApiV1AccountsByAccountNumberDeliveryAddressesByDeliveryAddressIdNextBestActionsCardsByCardKey,
} from '@eneco/dc-be/client';
import { TextLink } from '@eneco/sparky';
import { useContent } from '@sitecore/common';
import { DashboardOverviewRendering } from '@sitecore/types/DashboardOverview';
import { useSWRConfig } from 'swr';

import { StyledDashboardBlock } from './DashboardBlock';
import { DashboardLink } from './DashboardLink';
import { useAddressOptions } from '../../../../hooks/useAddressOptions';

export const PushDirectDebitCard = ({ card }: { card: PushDirectDebitCardResponse }) => {
  const { fields } = useContent<DashboardOverviewRendering>();
  const { selectedAccount, isCurrentAccountReader } = useSelfServiceAccount();
  const { addressIdentifier } = useAddressOptions();
  const { mutate } = useSWRConfig();

  const handleClose = async () => {
    try {
      const { response } =
        await deleteEnecoBeXapiSiteApiV1AccountsByAccountNumberDeliveryAddressesByDeliveryAddressIdNextBestActionsCardsByCardKey(
          {
            path: {
              accountNumber: selectedAccount.crmAccountNumber,
              deliveryAddressId: addressIdentifier,
              cardKey: card.key,
            },
            query: {
              Reason: 'userDismissed',
            },
          },
        );
      if (!response.ok) {
        throw new Error('Failed to delete push direct debit card');
      }
      mutate(`/accounts/${selectedAccount.crmAccountNumber}/delivery-addresses/${addressIdentifier}/next-best-actions`);
    } catch (error) {
      logger.error('Failed to delete push direct debit card', error as string);
    }
  };
  return (
    <StyledDashboardBlock>
      <RichText html={fields.pushDirectDebitCard?.description.value} />
      {!isCurrentAccountReader && (
        <>
          <DashboardLink
            emphasis="high"
            onClick={handleClose}
            trackingComponentName="push_direct_debit_dismiss_link"
            trackingComponentType="dashboard_link">
            {fields.pushDirectDebitCard?.closeLink.value.text || 'Nee [Not in Sitecore]'}
          </DashboardLink>
          <TextLink emphasis="high" href={fields.pushDirectDebitCard?.changeLink.value.href}>
            {fields.pushDirectDebitCard?.changeLink.value.text || 'Ja, pas aan [Not in Sitecore]'}
          </TextLink>
        </>
      )}
    </StyledDashboardBlock>
  );
};
